module.exports = __webpack_public_path__ + "img/img.b3898593.png";